import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data } from './types'

export const GET_CS_MANAGERS_FOR_SELECT: TypedDocumentNode<Data> = gql`
  query getCSManagersForSelect {
    customerSuccessUsers {
      nodes {
        id
        firstName
        lastName
      }
    }
  }
`
